// src/pages/BalanceDetails.js
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function BalanceDetails() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Önceki sayfaya geri dön
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Bakiyeniz
      </Typography>
      <Typography variant="body1">
        Detaylı bakiye bilgileri burada yer alacak...
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleBack}
        sx={{ mt: 2 }}>
        Geri Dön
      </Button>
    </Box>
  );
}

export default BalanceDetails;
